import React, {useEffect, useRef, useState} from 'react';
import projectApi from '../../api/project/project.ts';
import {Pagination, Typography} from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2";
import {useSearchParams} from "react-router-dom";
import ProjectCard from "src/components/project/ProjectCard";

const ProjectPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [projects, setProjects] = useState(null);
  const [projectCount, setProjectCount] = useState(null);
  const page = searchParams.get('page') ? Number(searchParams.get('page')) : 1;
  const itemsPerPage = 12;
  const containerRef = useRef();

  const fetchProjects = async () => {
    const response = await projectApi.retrieveCollection({ page: page, itemsPerPage: itemsPerPage });
    setProjects(response['hydra:member']);
    setProjectCount(response['hydra:totalItems']);
  }

  useEffect(() => {
    fetchProjects();
  }, [searchParams.get('page')]);

  const handlePageChange = (e, page) => {
    setSearchParams((prev) => ({
      ...prev,
      page: page
    }));
    containerRef.current.scrollIntoView({ behavior: 'smooth'});
  }

  return (
    <>
      <Typography variant="h2" mb={2}>Projecten</Typography>
      <Typography variant="body1" mb={2}>
        Hier zie je een overzicht van de beschikbare testen. Er zijn 3 type projecten:
        <ul>
          <li>Locatie testen: je komt dan naar onze testlocatie om producten te testen.</li>
          <li>Thuis testen: je krijgt de producten van ons toegestuurd om thuis te testen.</li>
          <li>Online onderzoek: vragen die je direct online kan beantwoorden. Je hebt geen product nodig.</li>
        </ul>
        Dit overzicht wordt bijgewerkt zodra er nieuwe testen zijn gepland en hierover zal je steeds per mail informatie ontvangen.
      </Typography>
      {projects && projects.length === 0 && <Typography variant="body">Er zijn op dit moment geen projecten waaraan je kunt deelnemen.</Typography>}
      <Grid2 container spacing={2} mb={2} ref={containerRef}>
        { projects && projects.map((project) => (
          <Grid2 key={project.id} xs={12} md={6}>
            <ProjectCard project={project} />
          </Grid2>
        ))}
      </Grid2>
      <Pagination
        page={page}
        onChange={handlePageChange}
        count={Math.ceil(projectCount / itemsPerPage)}
        color="primary" showFirstButton showLastButton
      />
    </>
  );
}

export default ProjectPage;

ProjectPage.propTypes = {}

ProjectPage.defaultProps = {}